import { Id, LaravelResponse, keyToUrl } from "@dgs/core";
import axios from "axios";
import { PaymentTransactionResource } from "../../types/paymentTransaction";

const completeTransactionKey = (transactionId: Id) => ["shop", "transactions", `${transactionId}`, "complete"];
const cancelTransactionKey = (transactionId: Id) => ["shop", "transactions", `${transactionId}`, "cancel"];

export const shopService = {
	completeTransactionKey,
	completeTransaction: (id: Id) =>
		axios.get<LaravelResponse<PaymentTransactionResource>>(keyToUrl(completeTransactionKey(id))),
	cancelTransactionKey,
	cancelTransaction: (id: Id) =>
		axios.get<LaravelResponse<PaymentTransactionResource>>(keyToUrl(cancelTransactionKey(id))),
};
